import { render, staticRenderFns } from "./bi-item-item.vue?vue&type=template&id=504c72b4&"
import script from "./bi-item-item.vue?vue&type=script&lang=ts&"
export * from "./bi-item-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports